import './client-requests.scss';

import { Collapse } from 'antd';
import dayjs from 'dayjs';
import { Link } from 'react-router';

import { ROUTES } from '@/components/Shared/routes/routes';
import { Button } from '@/components/Shared/ui';
import { BANKS_ICONS_NAMES, DictTypes } from '@/constants';
import { DownOutlined } from '@/media/antd-icons';
import { useAppSelector } from '@/store';
import type { TDataSource } from '@/types/dataSource';

import { findFinancedOfferDate } from '../../helpers/findFinancedOfferDate';
import { ClientMobile, RequestsCollapseHeader } from './ui';

type TClientRequestsDataProps = {
  requests: TDataSource[] | undefined;
  handleCreateNewReq: () => void;
  handleRequestInfo: (request: TDataSource) => void;
};

const ClientRequests = ({
  requests,
  handleRequestInfo,
  handleCreateNewReq
}: TClientRequestsDataProps) => {
  const { dicts } = useAppSelector((state) => state.dict);
  const banks = dicts?.[DictTypes.Banks]?.content;

  return (
    <div className="client-requests">
      <div className="client-requests__header">
        <h2 className="client-requests__title">Заявки: {requests?.length}</h2>
        <Button variant="filled-red" size="small" onClick={handleCreateNewReq}>
          <p>Новая заявка</p>
        </Button>
      </div>

      <Collapse
        expandIconPlacement="end"
        expandIcon={({ isActive }) => (
          <DownOutlined
            className="client-requests__arrow-icon"
            rotate={isActive ? 180 : 0}
          />
        )}
        items={
          requests
            ? requests.map((dataSource) => {
                const auto = dataSource.loan.auto
                  .toLowerCase()
                  .includes('undefined')
                  ? 'Авто не указано'
                  : dataSource.loan.auto;
                const bank = banks?.find(
                  (bank) => bank.name === dataSource.status.selectedBank
                );
                const bankInfo =
                  BANKS_ICONS_NAMES[
                    dataSource.status
                      .selectedBank as keyof typeof BANKS_ICONS_NAMES
                  ];

                return {
                  key: dataSource.id,
                  label: (
                    <RequestsCollapseHeader
                      auto={auto}
                      dataSource={dataSource}
                      bankInfo={{
                        name: bank?.fullname || bankInfo?.name,
                        icon: bank?.icon || bankInfo?.icon
                      }}
                    />
                  ),
                  children: (
                    <>
                      <div className="client-requests__table">
                        <table>
                          <thead>
                            <tr className="client-requests__table-header">
                              <th>ID заявки</th>
                              <th>Дата создания заявки</th>
                              <th>Марка и модель,год выпуска</th>
                              <th>Стоимость авто</th>
                              <th>Перв. взнос</th>
                              <th>Срок займа</th>
                              <th>Дата финансирования</th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr className="client-requests__table-body">
                              <td># {dataSource.client.code} </td>
                              <td>
                                {dayjs(dataSource?.created_at?.date).format(
                                  'DD.MM.YYYY'
                                )}
                              </td>
                              <td>{auto}</td>
                              <td>
                                {dataSource.loan.amount
                                  ? `${dataSource.loan.amount} ₸`
                                  : '—'}
                              </td>
                              <td>
                                {dataSource.loan.initialFee
                                  ? `${dataSource.loan.initialFee} ₸`
                                  : '—'}
                              </td>
                              <td>
                                {dataSource.loan.loanTerm
                                  ? `${dataSource.loan.loanTerm} мес.`
                                  : '—'}
                              </td>
                              <td>
                                {findFinancedOfferDate(dataSource.responses)}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="client-requests__table-mobile">
                        <ClientMobile dataSource={dataSource} />
                      </div>
                      {dataSource.status.isDraft ||
                      dataSource.status.isUnverified ? (
                        <Button
                          size="small"
                          fullWidth
                          onClick={() => handleRequestInfo(dataSource)}
                        >
                          Подробнее
                        </Button>
                      ) : (
                        <Link
                          className="client-requests__more-info"
                          to={ROUTES.autoCreditRequest(dataSource.id)}
                        >
                          Подробнее
                        </Link>
                      )}
                    </>
                  )
                };
              })
            : []
        }
      />
    </div>
  );
};

export default ClientRequests;
